import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSamplesDark = (_a) => {
  var _b = _a, { size, title = "SamplesDark" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M30.75 35.25H5.25a1.5 1.5 0 01-1.5-1.5V2.25a1.5 1.5 0 011.5-1.5h18l9 9v24a1.5 1.5 0 01-1.5 1.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M23.25.75v7.5a1.5 1.5 0 001.5 1.5h7.5l-9-9z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#F9FAFB",
    d: "M23.735 14.427a.754.754 0 00-.609-.167l-9 1.5a.75.75 0 00-.626.74v8.388a2.225 2.225 0 00-.75-.138A2.252 2.252 0 0010.5 27c0 1.24 1.009 2.25 2.25 2.25S15 28.24 15 27v-6.115l7.5-1.25v3.753a2.225 2.225 0 00-.75-.138 2.252 2.252 0 00-2.25 2.25c0 1.24 1.009 2.25 2.25 2.25S24 26.74 24 25.5V15c0-.22-.097-.43-.265-.573zM15 19.365v-2.23l7.5-1.25v2.23l-7.5 1.25z"
  }));
};
var SamplesDark = withIcon(SvgSamplesDark);

export { SamplesDark as default };
//# sourceMappingURL=SamplesDark.es.js.map
